/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconFlask2 = createReactComponent("outline", "flask-2", "IconFlask2", [["path", { "d": "M6.1 15h11.8", "key": "svg-0" }], ["path", { "d": "M14 3v7.342a6 6 0 0 1 1.318 10.658h-6.635a6 6 0 0 1 1.317 -10.66v-7.34h4z", "key": "svg-1" }], ["path", { "d": "M9 3h6", "key": "svg-2" }]]);

export { IconFlask2 as default };
//# sourceMappingURL=IconFlask2.mjs.map
